<template>
  <div class="tags">
    <a-tabs v-model:activeKey="tabStore.activeKey" type="editable-card" hide-add ref="tabs"
      :tabBarStyle="{ borderBottom: 'unset' }" @tabClick="onTabClick" @edit="onEdit">
      <template #leftExtra>
        <div class="admin-tabs-arrow" @click="() => onScroll(-100)">
          <huasky-icon icon="LeftOutlined" />
        </div>
      </template>
      <template #rightExtra>
        <div class="admin-tabs-arrow" @click="() => onScroll(100)">
          <huasky-icon icon="RightOutlined" />
        </div>
      </template>
      <a-tab-pane v-for="pane in tabStore.tabs" :key="pane.fullPath" :closable="!pane.affix">
        <template #tab>
          <a-dropdown :trigger="['contextmenu']">

            <div class="title">
              {{ pane.title }}
            </div>
            <template #overlay>
              <a-menu>
                <a-menu-item key="1" @click="() => tabStore.refresh(pane)">刷新</a-menu-item>
                <a-menu-item key="2" :disabled="pane.affix" @click="() => tabStore.remove(pane)">关闭当前页</a-menu-item>
                <a-menu-item key="3" @click="() => tabStore.removeOther(pane)">关闭其他</a-menu-item>
                <a-menu-item key="4" @click="() => tabStore.removeAll()">关闭所有</a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script setup lang="ts">
import Store from '@scripts/store/store'

const tabStore = Store.useTab()
const onTabClick = (key: string) => $router.push(key)
const onEdit = (fullpath: string) => {
  const pane = tabStore.tabs.filter(a => a.fullPath === fullpath)[0]
  tabStore.remove(pane)
}

const onScroll = (y: number) => {
  const $el = document.querySelector('.ant-tabs-nav-wrap')
  const event = new WheelEvent('wheel', { deltaX: 0, deltaY: y })
  $el?.dispatchEvent(event)
}

</script>
<style lang="scss" scoped>
.tags {
  z-index: 10;
  height: 42px;
  background: #fff;
  box-shadow: 1px 3px 3px rgba(0, 21, 41, .08);


  :deep(.ant-tabs-tab) {
    padding: 10px 15px;
    border: none;
    background-color: #fff;
  }

  :deep(.ant-tabs-tab-active) {
    background-color: #e9faf8;
    // border-bottom: 1px solid #2e9a92;
  }

  :deep(.ant-tabs-ink-bar-animated) {
    visibility: visible;
  }

  :deep(.ant-tabs-tab) {
    >div {
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.admin-tabs-arrow {
  padding: 0;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;

  .anticon {
    font-size: 12px;
    vertical-align: -1px;
  }
}

.title {
  display: inline;
  background-color: transparent;
  user-select: none;
}
</style>